import React, { memo, useMemo } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';
import { getAQIColor, getAQITextColor, formatAQI } from './utils/aqiUtils';

/**
 * Custom AQI Marker component with color-coded circle (no popup)
 */
const AQIMarker = memo(({ station, onClick, isSelected }) => {
    const { lat, lon, aqi, uid, poleStatus, status_for_color, poleNumber } = station;

    // Create custom icon with AQI value
    const icon = useMemo(() => {
        let color;
        let textColor = '#ffffff';
        let displayAqi;

        const apiColor = String(status_for_color || '').toLowerCase();

        if (apiColor === 'red') {
            color = '#ff0000';
            textColor = '#ffffff';
            // displayAqi = formatAQI(aqi);
        } else if (apiColor === 'green') {
            color = '#22c55e'; // Green to match dashboard active color
            textColor = '#ffffff';
            // displayAqi = formatAQI(aqi);
        } else if (apiColor === 'yellow') {
            color = '#EFB700'; // Gold/Yellow for inactive/Awaiting Connection
            textColor = '#ffffff';
            // displayAqi = '0';
        } else {
            // Fallback to local status parsing if status_for_color is not present
            const status = String(poleStatus || '').toLowerCase();
            if (status === 'offline') {
                color = '#ff0000';
                textColor = '#ffffff';
                // displayAqi = '0';
            } else if (status === 'Awaiting Connection') {
                color = '#EFB700';
                textColor = '#ffffff';
                // displayAqi = '0';
            } else {
                color = getAQIColor(aqi);
                textColor = getAQITextColor(aqi);
                // displayAqi = formatAQI(aqi);
            }
        }

        // Get the last 4 digits of the pole number as the display text
        const poleNumStr = String(poleNumber || uid || '');
        displayAqi = poleNumStr.length >= 4 ? poleNumStr.slice(-4) : poleNumStr;

        return L.divIcon({
            className: 'aqi-marker-icon',
            html: `
        <div class="aqi-marker ${isSelected ? 'aqi-marker-selected' : ''}" style="
          background-color: ${color};
          color: ${textColor};
          box-shadow: 0 2px 8px ${color}80;
        ">
          <span class="aqi-value" style="color: ${textColor};">${displayAqi}</span>
        </div>
      `,
            iconSize: [36, 36],
            iconAnchor: [18, 18],
        });
    }, [aqi, isSelected, poleStatus, status_for_color, poleNumber, uid]);

    // Handle click event
    const handleClick = () => {
        if (onClick) {
            onClick(uid);
        }
    };

    // Skip rendering if coordinates are missing or invalid
    if (lat == null || lon == null) {
        return null;
    }

    return (
        <Marker
            position={[lat, lon]}
            icon={icon}
            key={uid}
            eventHandlers={{
                click: handleClick,
            }}
        />
    );
});

AQIMarker.displayName = 'AQIMarker';

export default AQIMarker;
